import React from 'react';
import { Outlet } from 'react-router-dom';
import { DashboardLayout } from '../../../features/dashboard/components/DashboardLayout';

/**
 * AuthenticatedLayout — used for all logged-in user pages.
 *
 * Equivalent to Laravel's `layouts.app` Blade template.
 * Provides the dashboard chrome: top header bar, sidebar navigation,
 * mobile bottom nav, and a padded content area.
 *
 * Pages using this layout:
 * - Dashboard, Bookings, Trips, Fleet, Payments, Profile, etc.
 *
 * Individual pages no longer need to wrap themselves in <DashboardLayout>.
 * They just render their content and this layout wraps it automatically.
 */
export const AuthenticatedLayout: React.FC = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};
